import axios from "axios";
import api from "./api";
import { errorAlert, badRequestError } from "./errorHandling";

export const GET = async (URL) => {
    try {
        const response = await api.get(URL);
        if (response.data.status === "Success") {
            return response.data
        } else {
            return errorAlert(response?.data?.message);
        }
    } catch (error) {
        return badRequestError(error);
    }
};

export const GETDIRECTAPICALL = async (URL) => {
    try {
        const response = await axios.get(URL);
        if (response.status === 200) {
            return {
                status: "Success",
                ...response.data
            }
        } else {
            return errorAlert(response?.data?.message);
        }
    } catch (error) {
        return badRequestError(error);
    }
};

export const DOWNLOADFILE = async (URL, file_ext = null) => {
    try {
        const response = await api.get(URL, { responseType: 'blob' });
        
        if (response.status === 200) {
            let file_name = new Date().getTime();
            if(file_ext != null){
                file_name = file_name + "." + file_ext;
            }else{
                file_name = file_name + ".pdf";
            }

            let url = window.URL.createObjectURL(new Blob([response.data]));
            let link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', file_name);
            document.body.appendChild(link);
            link.click();

            return {
                status: "Success"
            }
        } else {
            return errorAlert(response?.data?.message);
        }
    } catch (error) {
        // return badRequestError(error);

        // If the server sent a JSON error inside a Blob, parse it
        if (error.response?.data instanceof Blob) {
            try {
                const text = await error.response.data.text(); // convert Blob to text
                const json = JSON.parse(text); // parse text to JSON
                const message = json?.message || "Something went wrong.";
                return errorAlert(message);
            } catch (parseError) {
                return errorAlert("Failed to parse error response.");
            }
        }

        // Fallback
        const fallbackMessage =
            error?.response?.data?.message ||
            error?.message ||
            "Unexpected error occurred.";

        return errorAlert(fallbackMessage);
    }
    
}